module.exports = __webpack_public_path__ + "0af6bb6bda7ad26bad23531425eeb550.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/call_your_elites-1050.webp
// module id = 199
// module chunks = 0